import { ControlState } from "@/domain/ticket-selection";

export class ControlStateService {
    private state: ControlState = {
        isFilterOpen: false,
        displayExitLayerButton: false,
        isPricelevelSelected: false
    };

    public get isFilterOpen(): boolean {
        return this.state.isFilterOpen;
    }

    public get displayExitLayerButton(): boolean {
        return this.state.displayExitLayerButton;
    }

    public get isPricelevelSelected(): boolean {
        return this.state.isPricelevelSelected;
    }

    public resetState() {
        this.state = {
            isFilterOpen: false,
            displayExitLayerButton: false,
            isPricelevelSelected: false
        };
    }

    public switchFilterDialogDisplayTo(val: boolean) {
        this.state.isFilterOpen = val;
    }

    public switchExitLayerButtonDisplayTo(val: boolean) {
        this.state.displayExitLayerButton = val;
    }

    public switchPricelevelSelectedTo(val: boolean) {
        this.state.isPricelevelSelected = val;
    }
}